import { gql } from '@apollo/client';

export default gql`
  mutation ExchangeHotelProduct($bookingReference: String!, $oldHotelInput: OldHotelInput!, $newHotelInput: NewHotelInput!) {
    exchangeHotelProduct(bookingReference: $bookingReference, oldHotelInput: $oldHotelInput, newHotelInput: $newHotelInput) {
      status
      reference
      totalPriceToBePaid: totalPriceToBePaidWithCurrency
    }
  }
`;
